module.exports = __webpack_public_path__ + "img/4.17422cd2.png";